import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class GroupValidationService {
	private _forceShowState = new BehaviorSubject<boolean>(false);

	get forceShowState$() {
		return this._forceShowState.asObservable();
	}

	set forceShowState(forceShowState: boolean) {
		this._forceShowState.next(forceShowState);
	}
}
